import Service, { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import ENV from 'bullitt-time-cloud-live/config/environment';

export default class CloudAjaxService extends Service {
  @service auth;
  @service router;

  @tracked isLoading = false;
  @tracked error = null;

  get apiEndpoint() {
    return ENV.APP.CLOUD_REST_API_ENDPOINT;
  }

  /**
   * Get headers for authenticated requests.
   */
  get authHeaders() {
    const headers = {};
    if (this.auth.authToken) {
      headers['Authorization'] = `Bearer ${this.auth.authToken}`;
    }
    return headers;
  }

  /**
   * Handle response errors, including auth failures.
   */
  handleResponseError(response) {
    if (response.status === 401 || response.status === 403) {
      console.log('[CloudAjax] Authentication failed, redirecting to login');
      this.auth.handleAuthFailure();
      this.router.transitionTo('login');
      throw new Error('Authentication required');
    }
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  async getEvents() {
    this.isLoading = true;
    this.error = null;
    try {
      const response = await fetch(`${this.apiEndpoint}/events`, {
        headers: this.authHeaders
      });
      if (!response.ok) this.handleResponseError(response);
      const data = await response.json();
      return data.events || [];
    } catch (error) {
      console.error('Error fetching events:', error);
      this.error = error;
      throw error;
    } finally {
      this.isLoading = false;
    }
  }

  async getEventTiming(eventId) {
    this.isLoading = true;
    this.error = null;
    try {
      const response = await fetch(`${this.apiEndpoint}/events/${eventId}/timing`, {
        headers: this.authHeaders
      });
      if (!response.ok) this.handleResponseError(response);
      return await response.json();
    } catch (error) {
      console.error(`Error fetching timing for event ${eventId}:`, error);
      this.error = error;
      throw error;
    } finally {
      this.isLoading = false;
    }
  }

  async getEventReference(eventId) {
    this.isLoading = true;
    this.error = null;
    try {
      const response = await fetch(`${this.apiEndpoint}/events/${eventId}/reference`, {
        headers: this.authHeaders
      });
      if (!response.ok) this.handleResponseError(response);
      return await response.json();
    } catch (error) {
      console.error(`Error fetching reference data for event ${eventId}:`, error);
      this.error = error;
      throw error;
    } finally {
      this.isLoading = false;
    }
  }
}
